import React from "react";
import s from "./StoreWrapper.module.css";
import { useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { useMediaQuery } from "react-responsive";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  branchSelect: (props) => ({
    marginRight: `2px`,
    backgroundColor: `transparent`,
    border: `1px solid white`,
    borderRadius: `3px`,
    height: `34px`,
    color: `white`,
    width: props.isLaptop ? `100px` : `150px`,
  }),
}));

const StoreWrapper = (props) => {
  const isLaptop = useMediaQuery({ query: "(max-width: 1536px)" });
  const stylesProperties = {
    isLaptop: isLaptop,
  };
  const classes = useStyles(stylesProperties);

  const { contentData } = useSelector((state) => state);

  const selectedOptionValue = localStorage.getItem("selectedOptionValue");

  const setOption = (e) => {
    const target = e.target;
    props.setPreloader(true);
    const format = props.data.dropdownsReducer.format;
    const supplierName = props.supplier;
    const productCategoryName = props.product;
    if (props.data.contentData.isActivePromosScreen) {
      props.getDataTable(
        target.value,
        format,
        supplierName,
        productCategoryName,
        props.data.contentData.searchValue,
        true
      );
    } else {
      props.getDataTableForRegularPrices(
        target.value,
        format,
        supplierName,
        productCategoryName,
        props.data.contentData.searchValue,
        true
      );
    }
  };

  return (
    <div className={s.header}>
      <Box>
        <Typography variant={isLaptop ? `body1` : `body2`} fontWeight={`bold`}>
          זיהוי החנות:
        </Typography>
      </Box>
      <div>
        <select
          id="branchSelect"
          value={selectedOptionValue}
          onChange={(e) => setOption(e)}
          className={classes.branchSelect}
          disabled={contentData.isPrintListOpened}
        >
          <option value="22">אשדוד</option>
          <option value="18">באר-שבע</option>
          <option value="17">גבעת-ברנר</option>
          <option value="12">חדרה</option>
          <option value="4">חיפה - הדר</option>
          <option value="5">חיפה - קרית אליעזר</option>
          <option value="11">יוקנעם</option>
          <option value="19">כפר-סבא</option>
          <option value="15">כרמיאל</option>
          <option value="10">כרמיאל-גבעת רם</option>
          <option value="2">נהריה</option>
          <option value="8">נצרת</option>
          <option value="3">נשר</option>
          <option value="14">נתניה</option>
          <option value="21">עכו</option>
          <option value="23">עפולה</option>
          <option value="20">פתח-תקווה</option>
          <option value="16">קרית חיים</option>
          <option value="13">ראשון-לציון</option>
        </select>
      </div>
    </div>
  );
};

export default StoreWrapper;
